import {GetterTree, MutationTree, Module, ActionTree} from 'vuex'
import {RootState, PropositionState} from '../types'
import {apiUrl} from '@/config/service'
import axios from 'axios'

type PropositionGetter = GetterTree<PropositionState, RootState>

const state: PropositionState = {
  count: null,
  proposition: null
}

export const getters: PropositionGetter = {
  propositionsCountGetter: (state) => state.count,
  propositionGetter: (state) => state.proposition
}

export const actions: ActionTree<PropositionState, RootState> = {
  async getPropositionsCountAction({commit}) {
    const {data} = await axios.get(`${apiUrl}/proposition/count`)
    commit('getPropositionsCountMutation', data)
    return data
  },
  async getPropositionByIdAction({commit}, id) {
    commit('resetPropositionMutation')
    const {data} = await axios.get(`${apiUrl}/proposition/${id}`)
    commit('getPropositionByIdMutation', data)
    return data
  },
  async createPropositionAction({commit}, formParams) {
    const {data} = await axios.post(`${apiUrl}/proposition`, formParams)
    return data
  },
  async updatePropositionAction({commit}, {id, formParams}) {
    const {data} = await axios.put(`${apiUrl}/proposition/${id}`, formParams)
    return data
  },
  async deletePropositionAction({commit}, id) {
    const {data} = await axios.delete(`${apiUrl}/proposition/${id}`)
    return id
  },
  async generatePDFPropositionAction({commit}, id) {
    const {data} = await axios.post(`${apiUrl}/proposition/${id}/generate`)
    return id
  }
}

const mutations: MutationTree<PropositionState> = {
  getPropositionsCountMutation(state, data) {
    state.count = data.count
  },
  getPropositionByIdMutation(state, data) {
    state.proposition = data
  },
  resetPropositionMutation(state) {
    state.proposition = null
  }
}

export const proposition: Module<PropositionState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
